import { Swiper, SwiperSlide } from "swiper/react";
import EnhancedImageViewer from "../../../../../../../components/EnhancedImageView";
import {
  FestivalCompetitionPosterImage,
  FestivalCompetitionPosterWrapper,
} from "./style";
import { useRabbitFestivalContext } from "../../../../hooks/festival-context";
import { useMemo, useState } from "react";

const RabbitFestivalCompetitionPoster = () => {
  const { competition } = useRabbitFestivalContext();
  const [selectedImageIndex, setSelectedImageIndex] = useState(-1);
  const images = useMemo(() => {
    if (!competition) return [];
    return competition.posterImages.map((item) => item.imageUrl);
  }, [competition]);

  return (
    <FestivalCompetitionPosterWrapper>
      {images.length === 0 ? (
        <div className="no-data">포스터가 존재하지 않습니다. </div>
      ) : (
        <Swiper
          slidesPerView={1.2}
          centeredSlides={true}
          spaceBetween={8}
          className="swiper"
        >
          {images.map((item, index) => (
            <SwiperSlide key={index}>
              <FestivalCompetitionPosterImage
                onClick={() => setSelectedImageIndex(index)}
              >
                <img src={item} alt="poster" />
              </FestivalCompetitionPosterImage>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
      {selectedImageIndex !== -1 && (
        <EnhancedImageViewer
          images={images || []}
          defaultIndex={selectedImageIndex}
          onClose={() => setSelectedImageIndex(-1)}
        />
      )}
    </FestivalCompetitionPosterWrapper>
  );
};

export default RabbitFestivalCompetitionPoster;
